import { z } from 'zod';

export const userPreferencesSchema = z.object({
  selectedDate: z.string(),
  hideAmounts: z.boolean(),
  menuOpened: z.boolean(),
  hideLogo: z.boolean().optional(),
  hideLogout: z.boolean().optional(),
  outside_plan: z
    .object({
      page: z.enum(['sources', 'calc', 'graph']),
      calc_tab: z.number(),
      source_tab: z.number(),
    })
    .partial()
    .optional(),
  plans: z
    .record(
      z.string(),
      z
        .object({
          page: z.enum(['sources', 'calc', 'statement', 'graph']),
          calc_tab: z.number(),
          source_tab: z.number(),
          selected_statement: z.number(),
          selected_dashboard_user: z.string(),
        })
        .partial(),
    )
    .optional(),
  has_seen_feature: z.object({}).optional(),
});

export type UserPreferencesSchemaType = z.infer<typeof userPreferencesSchema>;

const defaultValue: UserPreferencesSchemaType = {
  hideAmounts: false,
  hideLogo: false,
  hideLogout: false,
  menuOpened: true,
  selectedDate: '2022-01-01',
  plans: {},
  has_seen_feature: {
    source_tabs_new_location: false,
    plan_periods_changed_order: false,
    payroll_report: false,
    payment_request_alert: false,
  },
};

export const userPreferencesDefaultValue = JSON.stringify(defaultValue, null, '\t');
